import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map, switchMap } from 'rxjs/operators';

import { VendorsService } from '../../../../services/digital-footprint/vendors/vendors.service';
import * as actions from './vendors.actions';

@Injectable()
export class VendorsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: VendorsService,
  ) {}

  getVendors$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getVendors),
      switchMap(({ sortOptions, searchTerm, pageNumber, riskSeverity }) =>
        this.service
          .getVendors({
            ...sortOptions,
            searchTerm,
            pageNumber,
            filters: riskSeverity
              ? `riskSeverity=${riskSeverity}`
              : undefined,
          })
          .pipe(
            map((pagedVendors) =>
              actions.getVendorsSuccess({ pagedVendors }),
            ),
            catchError((error) => of(actions.getVendorsFailure(error))),
          ),
      ),
    ),
  );

  getVendorRiskSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getVendorRiskSummary),
      exhaustMap(() =>
        this.service.getVendorRiskSummary().pipe(
          map((riskSummary) =>
            actions.getVendorRiskSummarySuccess({ riskSummary }),
          ),
          catchError((error) =>
            of(actions.getVendorRiskSummaryFailure(error)),
          ),
        ),
      ),
    ),
  );

  getVendorAccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getVendorAccess),
      switchMap(({ companyVendorId }) =>
        this.service.getVendorAccess(companyVendorId).pipe(
          map((vendorAccess) =>
            actions.getVendorAccessSuccess({ vendorAccess }),
          ),
          catchError((error) => of(actions.getVendorAccessFailure(error))),
        ),
      ),
    ),
  );
}
